import { createIcon } from '@chakra-ui/react';

export default createIcon({
  displayName: 'CalendarIcon',
  viewBox: '-1 -1 17 17',
  defaultProps: {
    fill: 'none',
    boxSize: '16px',
  },
  path: (
    <>
      <path
        d="M5.5521 8.17676H4.4491C4.28507 8.17676 4.1521 8.30973 4.1521 8.47376V9.57676C4.1521 9.74079 4.28507 9.87376 4.4491 9.87376H5.5521C5.71613 9.87376 5.8491 9.74079 5.8491 9.57676V8.47376C5.8491 8.30973 5.71613 8.17676 5.5521 8.17676Z"
        fill="currentColor"
      />
      <path
        d="M5.5521 10.6523H4.4491C4.28507 10.6523 4.1521 10.7853 4.1521 10.9493V12.0523C4.1521 12.2164 4.28507 12.3493 4.4491 12.3493H5.5521C5.71613 12.3493 5.8491 12.2164 5.8491 12.0523V10.9493C5.8491 10.7853 5.71613 10.6523 5.5521 10.6523Z"
        fill="currentColor"
      />
      <path
        d="M8.5521 8.17676H7.4491C7.28507 8.17676 7.1521 8.30973 7.1521 8.47376V9.57676C7.1521 9.74079 7.28507 9.87376 7.4491 9.87376H8.5521C8.71613 9.87376 8.8491 9.74079 8.8491 9.57676V8.47376C8.8491 8.30973 8.71613 8.17676 8.5521 8.17676Z"
        fill="currentColor"
      />
      <path
        d="M8.5521 10.6523H7.4491C7.28507 10.6523 7.1521 10.7853 7.1521 10.9493V12.0523C7.1521 12.2164 7.28507 12.3493 7.4491 12.3493H8.5521C8.71613 12.3493 8.8491 12.2164 8.8491 12.0523V10.9493C8.8491 10.7853 8.71613 10.6523 8.5521 10.6523Z"
        fill="currentColor"
      />
      <path
        d="M11.558 8.17676H10.455C10.2909 8.17676 10.158 8.30973 10.158 8.47376V9.57676C10.158 9.74079 10.2909 9.87376 10.455 9.87376H11.558C11.722 9.87376 11.855 9.74079 11.855 9.57676V8.47376C11.855 8.30973 11.722 8.17676 11.558 8.17676Z"
        fill="currentColor"
      />
      <path
        d="M11.558 10.6523H10.455C10.2909 10.6523 10.158 10.7853 10.158 10.9493V12.0523C10.158 12.2164 10.2909 12.3493 10.455 12.3493H11.558C11.722 12.3493 11.855 12.2164 11.855 12.0523V10.9493C11.855 10.7853 11.722 10.6523 11.558 10.6523Z"
        fill="currentColor"
      />
      <path
        d="M14 6.2H2M10.6667 1V3.6M5.33333 1V3.6M5.2 14H10.8C11.9201 14 12.4801 14 12.908 13.7875C13.2843 13.6005 13.5903 13.3022 13.782 12.9353C14 12.5181 14 11.9721 14 10.88V5.42C14 4.3279 14 3.78184 13.782 3.36472C13.5903 2.9978 13.2843 2.69949 12.908 2.51254C12.4801 2.3 11.9201 2.3 10.8 2.3H5.2C4.07989 2.3 3.51984 2.3 3.09202 2.51254C2.71569 2.69949 2.40973 2.9978 2.21799 3.36472C2 3.78184 2 4.3279 2 5.42V10.88C2 11.9721 2 12.5181 2.21799 12.9353C2.40973 13.3022 2.71569 13.6005 3.09202 13.7875C3.51984 14 4.07989 14 5.2 14Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
});
